export default __webpack_public_path__ + "static/media/Collections-Logo__radPandas.468d00d1.png";